export default __webpack_public_path__ + "static/media/user-times-circle-tc.bf37bb5e.svg";